import Vue from 'vue';

import { nextNMonthJPs } from '@/utils/year_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';

export const namespaced = true;

export const state = {
  activations: [
    {
      id: '1',
      name: 'IDを今月から使えるようにする',
      note: '（今月から課金が発生します）',
      subNote: null,
      key: 'available-this-month',
    },
    {
      id: '2',
      name: '仮登録する',
      note: '（利用開始しない場合、180日後に削除されます）',
      subNote: null,
      key: 'temporary-registration',
    },
    {
      id: '3',
      name: '利用開始年月を設定して予約する',
      note: null,
      subNote: '（仮登録アカウントとして登録され、利用開始年月になると自動で使えるようになります）',
      key: 'make-reservation',
    },
  ],
};

export const getters = {
  getActivationById: (state) => (id) => {
    return state.activations.find((item) => item.id == id);
  },
  getActivationMonths: () => {
    if (Vue.config.stagingBuild) {
      return nextNDayJPs(5);
    }
    return nextNMonthJPs(5);
  },
};
